/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createExportTargetMappingDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	externalId: z.string(),
	exportIntegrationId: z.string().uuid(),
	syncDisqualifiedCandidates: z.boolean().optional().default(true),
})

export type CreateExportTargetMappingDataSchema = z.infer<typeof createExportTargetMappingDataSchema>
